import React, { FC, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { FormulaType } from '../../constants/formulaType';
import routes from '../../constants/routes';

// hooks
import useFilterParam from '../../hooks/aampeTable/useFilterParam';
import useFormulasCatalogQuery from '../../hooks/formulas/useFormulasCatalogQuery';
import { useGetFormulaChannelTabsData } from '../../hooks/formulas/useGetFormulaChannelTabsData';

// models
import { FormulaCategory } from '../../models/formula.model';

// components
import FormulasCatalog from './FormulasCatalog';

interface FormulasCatalogStatusProps {
    hasDeleteAccess: boolean;
    hasCreateFormulaAccess: boolean;
}

const FormulasCatalogStatus: FC<
    React.PropsWithChildren<FormulasCatalogStatusProps>
> = ({ hasDeleteAccess, hasCreateFormulaAccess }) => {
    const history = useHistory();
    const location = history.location;
    const status = location.pathname.replace(
        `${routes.formulasMain}/`,
        '',
    ) as FormulaCategory;

    const { formulaTypeInitialValue, tabs } =
        useGetFormulaChannelTabsData(status);

    const [formulaType, setFormulaType] = useFilterParam(
        '',
        'message_type',
        formulaTypeInitialValue,
    );

    useEffect(() => {
        if (!tabs.find((tab) => tab.key === formulaType)) {
            setFormulaType(formulaTypeInitialValue);
        }
    }, [tabs, formulaType, formulaTypeInitialValue, setFormulaType]);

    const { data, isLoading, isError, error } = useFormulasCatalogQuery(
        status,
        formulaType as FormulaType,
    );

    return (
        <FormulasCatalog
            messages={data}
            isError={isError}
            error={error}
            isLoading={isLoading}
            formulaType={formulaType as FormulaType}
            setFormulaType={setFormulaType as (value: FormulaType) => void}
            hasDeleteAccess={hasDeleteAccess}
            hasCreateFormulaAccess={hasCreateFormulaAccess}
        />
    );
};

export default FormulasCatalogStatus;
